export default __webpack_public_path__ + "static/media/process.b207e79d.gif";